import React, {useState, useEffect } from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi"; 

const MaTravelPackageEdit = ()=>{
     const [name, setName ] = useState('');
     const [daterange, setDaterange ] = useState('');
     const [totalcost, setTotalcost ] = useState('');
    const [redirect, setRedirect] = useState(false); 

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`maTravelPackage/${id}`);
                 setName(data.name);
                 setDaterange(data.daterange);
                 setTotalcost(data.totalcost);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`maTravelPackage/${id}`, {
            name,
            daterange,
            totalcost,
        });
        console.log(data);
        setRedirect(true);
    };
    
    if(redirect){
         return <Navigate to={'/maTravelPackage'} />
    }
    return (
        <Wrapper pageTitle={'Edit MaTravelPackage'}>
            <InnerNav createLink={'/maTravelPackageCreate'} listLink={'/maTravelPackage'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Name </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Name" value={name}
                        onChange = {e => setName(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Daterange </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Daterange" value={daterange}
                        onChange = {e => setDaterange(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Totalcost </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Totalcost" value={totalcost}
                        onChange = {e => setTotalcost(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default MaTravelPackageEdit;